import { ActionButton } from '../common/action_button';

export default {
  name: 'actionButton',
  obj: {
    controller: ActionButton,
    bindings: {
      action: '&',
      initialText: '<',
      busyText: '<',
      icon: '@',
      type: '@',
      risk: '@'
    },
    template: `
      <section ng-class="[$ctrl.type, $ctrl.risk]">
      <button ng-click="$ctrl.execute()">
          <label class="feedback">{{ $ctrl.initialText }}</label>
          <ng-include ng-if="$ctrl.isIconPresent" class="icon" src="$ctrl.iconPath"></ng-include>
          <ng-include class="icon spinner" src="'/images/spinner.svg'"></ng-include>
      </button>
      </section>
    `
  }
}